<nav class="navbar bg-primary navbar-dark navbar-expand-lg d-none d-lg-flex">
  <a class="navbar-brand ps-1 py-0" [routerLink]="['/']" routerLinkActive="router-link-active">
    <img class="ml-1 h-100" src="assets/images/logo.svg" draggable="false" />
  </a>

  <!-- Left Side Content -->
  <div class="navbar-collapse" id="navbarSupportedContent">
    <div class="nav-container">
      <ng-container *notInPopulation="[populations.Guardian]">
        <ul class="nav-links">
          <li class="nav-link-item">
            <a class="nav-link" [routerLink]="['/games']" routerLinkActive="router-link-active">
              {{ 'nav.play' | translate }}
            </a>
          </li>
          <ng-container *inProductCode="[productcode.PaidKid]">
            <li class="nav-link-item">
              <a class="nav-link" [routerLink]="['/challenges']" routerLinkActive="router-link-active">
                {{ 'nav.challenges' | translate }}
              </a>
            </li>
          </ng-container>
          <li class="nav-link-item">
            <a class="nav-link" [routerLink]="['/worksheet']" routerLinkActive="router-link-active">
              {{ 'nav.worksheet' | translate }}
            </a>
          </li>
          <li class="nav-link-item">
            <a class="nav-link" [routerLink]="['/youth']" routerLinkActive="router-link-active">
              {{ 'nav.youth' | translate }}
            </a>
          </li>
        </ul>
      </ng-container>
    </div>
  </div>
  <button
    class="nav-link btn text-white d-flex align-items-center mx-2 px-0 justify-content-end ms-auto"
    (click)="isNavOpen = !isNavOpen"
    attr.aria-label="{{ 'nav.account.menu.screenreader' | translate }}"
    tabindex="-1"
    focusTab
  >
    <i class="material-symbols-outlined">menu</i>
  </button>
</nav>

<div class="right-nav-menu-overlay" *ngIf="isNavOpen" [@rightMenuOverlayAnimation]></div>
<div class="right-nav-menu shadow" [@rightNavAnimation]="isNavOpen ? 'open' : 'close'" [ngClass]="{ open: isNavOpen }">
  <div class="right-nav-menu-header">
    <div id="brand-logo">
      <ng-container *inPopulation="[populations.Kids]">
        <ng-container *inProductCode="[productcode.FreeKid]">
          <img alt="junior jays logo" src="assets/images/jr_jays_logo.png" draggable="false" />
        </ng-container>
        <ng-container *inProductCode="[productcode.PaidKid]">
          <img src="assets/images/kids/JJAllStar.png" alt="junior all star logo" draggable="false" />
        </ng-container>
      </ng-container>
      <ng-container *inPopulation="[populations.Guardian]">
        <img src="assets/images/logo.svg" alt="junior all star logo" draggable="false" />
      </ng-container>
    </div>
    <button class="btn-nav-close pe-0" (click)="isNavOpen = false"><i class="material-icons text-white">close</i></button>
  </div>

  <ng-container *ngIf="memberDetails$ | async as memberDetails">
    <div class="member-info">
      <div class="d-flex justify-content-between align-items-center">
        <!--Name and ID-->
        <div class="card-id text-start">
          <h5 class="mb-1 card-name text-white">{{ memberDetails.FirstName }} {{ memberDetails.Surname }}</h5>
          <div class="d-flex product-code mt-2 font-size-14">
            <div *inProductCode="[productcode.FreeKid]" class="font-size-14 mb-2">{{ 'member.card.free' | translate }}</div>
            <div *inProductCode="[productcode.PaidKid]" class="font-size-14 mb-2">{{ 'member.card.paid' | translate }}</div>
            <div *inPopulation="[populations.Guardian]" class="font-size-14 mb-2">
              {{ 'member.card.guardian' | translate: { externalRefNumber: memberDetails.ExternalRefNumber } }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right-nav-menu-list">
      <ng-container *notInPopulation="[populations.Kids]">
        <a
          class="right-nav-menu-item text-white"
          [routerLink]="['/account']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-text">{{ 'nav.profile' | translate }}</div>
        </a>

        <a
          class="right-nav-menu-item text-white"
          [routerLink]="['/terms']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-text">{{ 'nav.terms' | translate }}</div>
        </a>
      </ng-container>

      <ng-container *inPopulation="[populations.Kids]">
        <a
          class="right-nav-menu-item text-white"
          [routerLink]="['/games']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-text">{{ 'nav.games' | translate }}</div>
        </a>
        <ng-container *inProductCode="[productcode.PaidKid]">
          <a
            class="right-nav-menu-item text-white"
            [routerLink]="['/challenges']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-text">{{ 'nav.challenges' | translate }}</div>
          </a>
        </ng-container>
        <a
          class="right-nav-menu-item text-white"
          [routerLink]="['/worksheet']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-text">{{ 'nav.worksheets' | translate }}</div>
        </a>
        <a
          class="right-nav-menu-item text-white"
          [routerLink]="['/youth']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-text">{{ 'nav.youth' | translate }}</div>
        </a>
      </ng-container>

      <!-- Privacy Policy -->
      <a class="right-nav-menu-item text-white" href="{{ 'mlb.privacy.url' | translate }}">
        <div class="nav-text">{{ 'nav.mlb.privacy.url' | translate }}</div>
      </a>
      <!-- Terms Of Use -->

      <a class="right-nav-menu-item text-white" href="{{ 'mlb.terms.use.url' | translate }}">
        <div class="nav-text">{{ 'nav.mlb.terms.url' | translate }}</div>
      </a>
      <ng-container *inPopulation="[populations.Guardian]">
        <ng-container *ngIf="children$ | async as children">
          @if (children.data?.length > 1) {
            <a class="right-nav-menu-item text-white" href="{{ discountURL }}" target="_blank">
              <div class="nav-text">{{ 'nav.discount' | translate }}</div>
            </a>
          }
        </ng-container>
      </ng-container>
    </div>
    <div class="copy-right-section">
      <p [innerHtml]="'copy.right' | translate | markdownTranslate"></p>
    </div>
    <ng-container *notInPopulation="[populations.Kids]">
      <a class="logout-btn text-white cursor-pointer" (click)="logout()">
        <i class="material-symbols-outlined me-2">logout</i>
        <span>{{ 'nav.log.out' | translate }}</span>
      </a>
    </ng-container>
    <ng-container *inPopulation="[populations.Kids]">
      <a class="logout-btn btn btn-danger text-white cursor-pointer d-flex justify-content-center" (click)="switchToGuardian()">
        <i class="material-symbols-outlined me-2">logout</i>
        <span>{{ 'right.nav.back.to.guardian' | translate }}</span>
      </a>
    </ng-container>
  </ng-container>
</div>

<ng-template #memberDetailsLoading>
  <div class="user-box d-block text-center text-on-primary px-4">
    <fgbcl-loading [size]="'small'"></fgbcl-loading>
  </div>
</ng-template>
